import "./ProfilePage.scss";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { store } from "../../../../store/configureStore";
import * as accountActions from "../../../../store/actions/accountActions";
import { sendAccount } from "../../../../api/account";
import { Trans, withTranslation } from "react-i18next";
import images from "../../../../../src/ressources/images";
import InsInput from "../../../../components/InsInput/InsInput";
import InsCheckbox from "../../../../components/InsCheckbox/InsCheckbox";
import Validate from "../../../../ressources/validation";
import ValidatePassword from "../../../../components/ValidatePassword/ValidatePassword";
// import * as loadImage from "blueimp-load-image";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { connect } from "react-redux";
import * as language from "date-fns/locale";
import { XHRImage as Image } from "../../../../components/Media/Image";

export class ProfilePageEdit extends Component {
  constructor(props) {
    super(props);

    const date = new Date();
    this.max_year = new Date(
      date.getFullYear() - 16,
      date.getMonth(),
      date.getDate()
    );
    this.min_year = new Date(
      date.getFullYear() - 100,
      date.getMonth(),
      date.getDate()
    );

    this.state = {
      account: this.props.account,
      profileDatas: { ...this.props.account, password: "" },
      passwordError: "",
      oldPasswordError: "",
      passwordConfirmError: "",
      birthdate: "",
      birthdateError: "",
      formError: "",
      editPassword: false,
      preview: false,
      cpError: false,
      phoneError: false,
      accountUpdated: false,
      optins_link: {
        gdpr: this.props.config.register.opt_ins.ppFilePath
          ? this.props.config.register.opt_ins.ppFilePath
          : null,
        tou: this.props.config.register.opt_ins.touFilePath
          ? this.props.config.register.opt_ins.touFilePath
          : null,
      },
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { preview, profileDatas: { picture } } = this.state;
    const { account: { picture: apiPicture } } = this.props;

    if (prevState.account !== this.props.account) {
      const previewImage = preview ? picture : apiPicture; 
      this.setState({
        account: this.props.account,
        profileDatas: { ...this.state.profileDatas, ...this.props.account, picture: previewImage },
      });
    }
  }

  componentDidMount() {
    const datePickers = document.getElementsByClassName(
      "react-datepicker__input-container"
    );
    Array.from(datePickers).forEach((el) =>
      el.childNodes[0].setAttribute("readOnly", true)
    );
  }

  /**
   * Envoie les informations du compte (informations stockées dans le state)
   */
  sendAccountDatas = (e) => {
    e.preventDefault();
    const { cpError, phoneError, profileDatas } = this.state;
    const { password } = this.state.profileDatas;

    this.setState({ formError: "" });

    if (password !== "") {
      if (!this._validateOldPassword()) {
        return;
      }
    }

    if (!cpError && !phoneError) {
      sendAccount(profileDatas)
        .then((data) => {
          this.accountUpdated();
          store.dispatch(accountActions.setAccountDatas(data));
        })
        .catch((error) => {
          this.setState({ formError: error });
        });
    }
  };

  accountUpdated = () => {
    this.setState({ accountUpdated: true, preview: false });
    setTimeout(() => {
      this.setState({ accountUpdated: false });
    }, 3000);
  };

  /**
   * Change state datas input text
   */
  handleChange = (params) => (event) => {
    const value = event.target.value;

    this.setState((prevState) => ({
      profileDatas: {
        ...prevState.profileDatas,
        [params]: value,
      },
    }));
  };

  /**
   * Change state datas checkbox
   */
  _handleOptin = (input) => (e) => {
    const value = e.target.checked;

    this.setState((prevState) => ({
      profileDatas: {
        ...prevState.profileDatas,
        [input]: value,
      },
    }));
  };

  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  loadImageUrl = async (input) => {
    const base64 = await this.toBase64(input.files[0]);
    this.setState({
      profileDatas: { ...this.state.profileDatas, picture: base64 },
      preview: true,
    });
  };

  /**
   * Change state datas input file (img)
   */
  onImageChange = async (event) => {
    if (event.target.files && event.target.files[0]) {
      this.loadImageUrl(event.target);
    }
    // Formdata avec un append 'avatar' de event.target.files pour une requête post avec le fichier directement (evol)
  };

  _handleBirthdate = (value, locale = false) => {
    if (value > this.max_year) {
      value = this.max_year;
    } else if (value < this.min_year) {
      value = this.min_year;
    }

    this.setState((prevState) => ({
      profileDatas: {
        ...prevState.profileDatas,
        birthdate: value,
      },
    }));
  };

  _phoneValidation = () => {
    const { profileDatas } = this.state;
    profileDatas.phone.length < 10
      ? this.setState({ phoneError: true })
      : this.setState({ phoneError: false });
  };

  _cpValidation = () => {
    const { profileDatas } = this.state;
    profileDatas.postal_code?.length < 5
      ? this.setState({ cpError: true })
      : this.setState({ cpError: false });
  };

  /**
   * Valide le champ password
   */
  _validatePassword = () => {
    const error = Validate("password", this.state.profileDatas.password);
    this.setState({
      passwordError: error,
    });
    return !error;
  };

  /**
   * Valide la confirmation du champ password
   */
  _validatePasswordConfirm = () => {
    const { password, passwordConfirm } = this.state.profileDatas;
    const { t } = this.props;
    if (
      password !== passwordConfirm &&
      !Validate("password", this.state.profileDatas.password)
    ) {
      this.setState({
        passwordConfirmError: t("error_password_not_same"),
      });
    } else {
      this.setState({
        passwordConfirmError: "",
      });
    }
    return password === passwordConfirm;
  };

  _validateOldPassword = () => {
    const { oldPassword } = this.state.profileDatas;
    const { t } = this.props;

    if (oldPassword === "") {
      this.setState({
        oldPasswordError: t("error_old_password_missing"),
      });
    } else {
      this.setState({
        oldPasswordError: "",
      });
    }

    return oldPassword !== "";
  };

  _editPassword = () => {
    this.setState({ editPassword: !this.state.editPassword });
  };

  editPicture = () => {
    this.refs["edit_picture"].click();
  };

  _renderDateFormat = (localLng) => {
    if (localLng === "en-GB" || localLng === "en-US" || localLng === "es-US")
      return "MM/dd/yyyy";
    return "dd/MM/yyyy";
  };

  render() {
    const { config, t, i18n } = this.props;
    const { person, shop, connect } = config.register;
    const { country } = config;
    const {
      accountUpdated,
      cpError,
      editPassword,
      phoneError,
      profileDatas,
      passwordConfirmError,
      passwordError,
      oldPasswordError,
      preview,
      formError,
      optins_link,
    } = this.state;
    const { birthdate, firstname, lastname, password, picture, optin_wall } =
      profileDatas;


    let locale = i18n.language.replace(/-/g, "");
    let fullLocal = i18n.language;

    const languages = Object.keys(language);
    if (!languages.includes(locale)) {
      locale = locale.substring(0, 2);
      if (!languages.includes(locale)) {
        locale = "fr";
      }
    }

    registerLocale(`${locale}`, language[locale]);
    setDefaultLocale(`${locale}`);

    return (
      <div className="bg_white">
        <form onSubmit={this.sendAccountDatas} className="profile_container">
          <div className="column_center">
            <Link
              to={{
                pathname: "/profile",
                state: { transitionName: "slide_out" },
              }}
              className="back_link"
            ></Link>
            <div onClick={this.editPicture} className="profil_picture">
              {preview ? (
                <img src={picture} alt="preview" />
              ) : picture ? (
                <Image src={picture} alt="" />
              ) : (
                <img src={images.icon_user} alt="" />
              )}
            </div>
            <div className="input_file">
              <label htmlFor="file" className="label-file">
                {t("change_avatar")}
              </label>
              <input
                ref="edit_picture"
                type="file"
                accept="image/*"
                onChange={this.onImageChange}
              />
            </div>
          </div>
          <div className="send_wrapper">
            <div className="can_edit">
              {person[person.findIndex((el) => el.name === "firstname")] && (
                <InsInput
                  name="firstname"
                  type="text"
                  placeholder={t("firstname")}
                  value={firstname ? firstname : ""}
                  disabled
                />
              )}

              {person[person.findIndex((el) => el.name === "lastname")] && (
                <InsInput
                  name="lastname"
                  type="text"
                  placeholder={t("lastname")}
                  value={lastname ? lastname : ""}
                  disabled
                />
              )}

              {person[person.findIndex((el) => el.name === "birthdate")] && (
                <DatePicker
                  selected={birthdate ? new Date(birthdate) : ""}
                  onChange={(value) => this._handleBirthdate(value, fullLocal)}
                  placeholderText={t("birthdate")}
                  minDate={this.min_year}
                  maxDate={this.max_year}
                  dateFormat={language[locale].formatLong.date({
                    width: "short",
                  })}
                  locale={locale}
                  className="ins_input ins_datePicker"
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  popperPlacement="top-center"
                />
              )}
              {person[person.findIndex((el) => el.name === "user_address")] && (
                <InsInput
                  name="address"
                  type="text"
                  placeholder={t("address")}
                  value={profileDatas.address ? profileDatas.address : ""}
                  onChange={this.handleChange("address")}
                  maxLength="115"
                />
              )}
              {person[person.findIndex((el) => el.name === "user_address")] && (
                <InsInput
                  name="city"
                  type="text"
                  placeholder={t("city")}
                  value={profileDatas.city ? profileDatas.city : ""}
                  onChange={this.handleChange("city")}
                />
              )}
              {person[person.findIndex((el) => el.name === "user_address")] && (
                <>
                  <InsInput
                    name="postal_code"
                    type="number"
                    onInput={(e) => {
                      e.target.value = e.target.value.slice(0, 5);
                    }}
                    maxLength="5"
                    placeholder={t("postal_code")}
                    value={
                      profileDatas.postal_code ? profileDatas.postal_code : ""
                    }
                    onChange={this.handleChange("postal_code")}
                    onBlur={this._cpValidation}
                  />
                  {cpError && (
                    <div
                      className={cpError ? "phone_error mb20" : "phone_error"}
                    >
                      {t("cp_error")}
                    </div>
                  )}
                </>
              )}

              {connect[connect.findIndex((el) => el.name === "phone")] && (
                <>
                  <InsInput
                    className={phoneError ? "mb0" : "mb20"}
                    name="phone"
                    type="tel"
                    placeholder={t("phone")}
                    value={profileDatas.phone ? profileDatas.phone : ""}
                    onChange={this.handleChange("phone")}
                  />
                  {phoneError && (
                    <div
                      className={
                        phoneError ? "phone_error mb20" : "phone_error"
                      }
                    >
                      {t("phone_number_error")}
                    </div>
                  )}
                </>
              )}

              {!editPassword && (
                <div
                  className="edit_password"
                  onClick={() => this._editPassword()}
                >
                  {t("password_change")}
                </div>
              )}
              {editPassword && (
                <div>
                  <InsInput
                    name="password"
                    type="password"
                    placeholder={t("new_password")}
                    onChange={this.handleChange("password")}
                    error={passwordError}
                  />
                  <InsInput
                    name="passwordConfirm"
                    type="password"
                    placeholder={t("password_confirm")}
                    onChange={this.handleChange("passwordConfirm")}
                    onBlur={this._validatePasswordConfirm}
                    error={passwordConfirmError}
                  />
                  <InsInput
                    name="oldPassword"
                    type="password"
                    placeholder={t("current_password")}
                    onChange={this.handleChange("oldPassword")}
                    onBlur={this._validateOldPassword}
                    error={oldPasswordError}
                  />
                  <div className="profil-validate-password">
                    <ValidatePassword value={password} activeColor="#32CD32">
                      {t("help_password")}
                    </ValidatePassword>
                  </div>
                </div>
              )}
              {/* <input type="text" placeholder="Date de naissance" value='07/10/90' /> Infos manquante */}
              <InsCheckbox
                label={
                  <Trans i18nKey="optin_wall_profil">
                    By posting content on One Retail I agree to the
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={optins_link.tou}
                    >
                      Terms of Use
                    </a>
                    governing the rights granted to L’Oréal {country} on such
                    content and to the use of my personal data in order for
                    L’Oréal {country} to publish and manage my post in the
                    condition of the
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={optins_link.gdpr}
                    >
                      Privacy Policy.
                    </a>
                    <br />
                    <br />
                    You may delete your content at any time in your personal
                    account.
                  </Trans>
                }
                name="optin_wall"
                onClick={this._handleOptin("optin_wall")}
                checked={optin_wall}
              />
            </div>

            <div className="cant_edit">
              <div className="input_group_label">Retailer</div>

              <InsInput
                  name="retailer_name"
                  type="text"
                  placeholder={t("retailer_name")}
                  value={
                    profileDatas.store[0].retailer
                        ? profileDatas.store[0].retailer
                        : ""
                  }
                  disabled
              />

              <div className="input_group_label">Shop</div>

              <InsInput
                  name="shop_code"
                  type="text"
                  placeholder={t("shop_code")}
                  value={
                    profileDatas.store[0].code
                  }
                  disabled
              />
              <InsInput
                name="shop_name"
                type="text"
                placeholder={t("shop_name")}
                value={
                  profileDatas.store[0].name
                    ? profileDatas.store[0].name
                    : profileDatas.store[0].retailer
                      ? profileDatas.store[0].retailer
                      : ""
                }
                disabled
              />
              <InsInput
                  name="address"
                  type="text"
                  placeholder={t("address")}
                  value={profileDatas.store[0] ? profileDatas.store[0].address : ""}
                  disabled
              />
              <InsInput
                name="city"
                type="text"
                placeholder={t("city")}
                value={profileDatas.store[0] ? profileDatas.store[0].city : ""}
                disabled
              />
              <InsInput
                  name="city"
                  type="text"
                  placeholder={t("city")}
                  value={profileDatas.store[0] ? profileDatas.store[0].country : ""}
                  disabled
              />
            </div>

            <p className="profile-edit-bottom-text">
              {t("profile_edit_bottom_text")}
            </p>
          </div>

          <div className="last_form">
            {accountUpdated && (
              <div className="account_updated">{t("account_updated")}</div>
            )}
            {formError && (
              <div className="account_updated fail">{t(formError)}</div>
            )}
            <input
              className="register"
              type="submit"
              disabled={phoneError || cpError ? true : false}
              value={t("save")}
            />
            <input
              className="reset"
              type="reset"
              value={t("cancel")}
              onClick={() => this.props.history.goBack()}
            />
          </div>
        </form>
      </div>
    );
  }
}

//extract data from the redux store
const mapStateToProps = (state) => ({
  account: state.account,
  config: state.config,
  auth: state.auth,
});

export default connect(mapStateToProps)(
  withTranslation()(ProfilePageEdit)
);
